import {AbstractVisualFeature} from '../../visual-feature.js';
import {CardsAndPromotions} from '../cards-and-promotions.js';

import {preBuiltCardsFactory} from './pre-built-cards.factory.js';

import PALETTE_SCHEMA from './pre-built-cards.palette-schema.yaml';

class PreBuiltCardsFeature extends AbstractVisualFeature {
    get name() {
        return 'PreBuiltCards';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return preBuiltCardsFactory(PALETTE);
    }
}

new PreBuiltCardsFeature(CardsAndPromotions);
